import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import DeviceConfigWindow from "./DeviceConfig/DeviceConfigWindow";
import WidgetSettingsWindow from "./WidgetSettingsWindow";

import QuerxPrompt from "./Popups/QuerxPrompt";
import MobileQRWindow from "./Popups/MobileQRWindow";

import { actionCreators as devicesActionCreators } from "../../../actions/devicesActions";
import { actionCreators as uiActionCreators } from "../../../actions/uiActions";


const ModalComponent = props => {
  let {
    toggleMobileQrSettings,
    contentForModal,
    toggleDeviceSettings,
    toggleWidgetSettings,
    resetDetectedQuerx,
    requestActivateTemplate,
    detectedQuerx,
    addToDeviceTemplateBlacklist,
    removeFromDeviceTemplateBlacklist,
    user
  } = props;
  if (!contentForModal) {
    return null;
  }

  let Pane;

  if (contentForModal.type === "dataConfig") {
    //console.log("112-1", contentForModal.sensorKey)
    Pane = (
      <DeviceConfigWindow
        {...props}
        device={contentForModal.device}
        showSensor={contentForModal.sensorKey}
      />
    );
  } else if (contentForModal.type === "widgetConfig") {
    Pane = (
      <WidgetSettingsWindow
        onHide={() => {
          toggleWidgetSettings(contentForModal.widgetid);
        }}
        widgetid={contentForModal.widgetid}
      />
    );
  } else if (contentForModal.type === "querxDetected") {
    Pane = (
      <QuerxPrompt
        onHide={() => {
          resetDetectedQuerx();
        }}
        requestActivateTemplate={requestActivateTemplate}
        detectedQuerx={detectedQuerx}
        addToDeviceTemplateBlacklist={addToDeviceTemplateBlacklist}
        removeFromDeviceTemplateBlacklist={removeFromDeviceTemplateBlacklist}
      />
    );
  } else if(contentForModal.type === "mobileQR") {
    Pane = (
      <MobileQRWindow onHide={toggleMobileQrSettings} user={user}/>
    )
  }

  let onModalClick = evt => {
    if (evt.target.classList.contains("modal")) {
      if (contentForModal.type === "dataConfig") {
        toggleDeviceSettings(contentForModal.device.uid);
      } else if (contentForModal.type === "widgetConfig") {
        toggleWidgetSettings(contentForModal.widgetid);
      } else if (contentForModal.type === "mobileQR") {
        toggleMobileQrSettings()
      }
    }
  };

  return (
    <div className="modal" onClick={onModalClick}>
      {Pane}
    </div>
  );
};

let contentForModal = state => {
  let configPane;
  // Popup for recognized Querx Palamoa template
  if (!!state.ui.detectedQuerx) {
    configPane = { type: "querxDetected" };
  }
  // Config Panes for the devices
  if (!!state.ui.deviceSettingsOpen.deviceUid) {
    let dev = state.devices.filter(device => {
      return device.uid === state.ui.deviceSettingsOpen.deviceUid;
    })[0];
    configPane = {
      type: "dataConfig",
      device: dev,
      sensorKey: state.ui.deviceSettingsOpen.sensorKey
    };
  } else if (!!state.ui.widgetSettingsOpen.widgetid) {
    configPane = {
      type: "widgetConfig",
      widgetid: state.ui.widgetSettingsOpen.widgetid
    };
  }

  if (!!state.ui.mobileQRWindowOpen) {
    configPane = { type: "mobileQR"};
  }
  return configPane;
};

const mapStateToProps = state => {
  let content = contentForModal(state);

  return {
    contentForModal: content,
    detectedQuerx: state.ui.detectedQuerx,
    user: state.user
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...devicesActionCreators, ...uiActionCreators },
    dispatch
  );
}

const Modal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalComponent);

export default Modal;
